<template lang="pug">
    div
        div
            h2 {{mainTitle}}
            p {{subTitle}}
            br
            br
        div(v-if="registerMethod !== 'Inode_admin_only'")     
            h3 {{step[0]}} {{step1Title}}
            p {{step1SubTitle}}
            p(v-if="selectedToken") {{$t("global.selected")}}: {{ selectedToken }}
            p(v-else) {{$t("nodeRegisteration.noVailableText")}}
            br
            //- Poptip(placement="top" width="720" transfer)
                Button(size="small") {{viewTokensText}}
                div(slot="content")
                    NodeTokenListTable(:selectedToken="selectedToken" @onSelectToken="onSelectToken" :tokenData="tokenData" :nodeType="nodeType" :groupName="registerMethod == 'Double_token' && $store.state.queryGroupName == 'all' ? chooseGroupName : $store.state.queryGroupName")
            Divider(plain)
                Button(@click="showTokenList = !showTokenList") {{viewTokensText}}
            NodeTokenListTable(v-if="showTokenList" :selectedToken="selectedToken" @onSelectToken="onSelectToken" :tokenData="tokenData" :nodeType="nodeType" :groupName="registerMethod == 'Double_token' && $store.state.queryGroupName == 'all' ? chooseGroupName : $store.state.queryGroupName" @reloadData="getTokenList")
            br
            br
        div
            h3 {{step[1]}} {{step2Title}}
            br
            Alert
                template(slot="desc")
                    CopyText(style="float: right" :text="nodeRegisterCommandsString")
                    span(style="white-space: pre-line") {{ nodeRegisterCommandsString }}
</template>
<script>
import NodeTokenListTable from "@/components/NodeRegisteration/NodeTokenListTable";
import { _getNodeRegisterTokens } from "@/api/rest/index";
import { _getNodeRegisterCommands } from "@/api/group";

export default {
    name: "NodeRegisterInfo",
    props: {
        chooseGroupName: { type: [String, Array], default: [[], ""] },
        chooseServiceProvideType: {},
        registerMethod: { type: String, default: "Double_token" },
        nodeType: { type: String, default: "slb" }
    },
    components: { NodeTokenListTable },
    watch: {
        chooseGroupName: {
            deep: true,
            handler: function(newVal) {
                this.getNodeRegisterCommands(this.registerMethod);
            }
        }
    },
    created() {},
    beforeDestroy() {},
    data() {
        return {
            showTokenList: false,
            tokenData: [],
            selectedToken: "",
            defaultToken: "",
            nodeRegisterCommands: []
        };
    },
    methods: {
        async getTokenList() {
            try {
                let getNodeTokenResult = await _getNodeRegisterTokens({
                    groupName:
                        this.registerMethod == "Double_token" && this.$store.state.queryGroupName == "all"
                            ? this.chooseGroupName
                            : this.$store.state.queryGroupName,
                    nodeType: this.nodeType
                });
                this.tokenData = getNodeTokenResult.data.tokens;

                let firstAvailableToken = this.tokenData.find(e => e.active == false);
                if (firstAvailableToken) {
                    this.defaultToken = firstAvailableToken.token;
                    this.selectedToken = firstAvailableToken.token;
                }
                this.getNodeRegisterCommands(this.registerMethod);
            } catch (err) {
                let errorObject = Object.assign({}, err);
                if (errorObject.response) {
                    this.$store.commit("SET_FAIL_PAYMENT_GROUP", errorObject.response.data.groupInfo);
                    this.$store.commit("SET_isPaymentOpened", true);
                }
            }
        },
        async onSelectToken(token) {
            this.selectedToken = token;
            await this.getNodeRegisterCommands(this.registerMethod);
        },
        async getNodeRegisterCommands(val) {
            let nodeRegisterCommands = await _getNodeRegisterCommands({
                groupName:
                    this.chooseGroupName == "None" || this.chooseGroupName == null || this.chooseGroupName == ""
                        ? "all"
                        : this.chooseGroupName.toString(),
                token: this.selectedToken,
                nodeType: this.nodeType,
                registerMethod: val,
                serviceProvideType: this.chooseServiceProvideType
            });
            this.nodeRegisterCommands = nodeRegisterCommands;
        }
    },
    mounted() {
        this.getTokenList();
        this.getNodeRegisterCommands(this.registerMethod);
    },
    computed: {
        nodeRegisterCommandsString() {
            return this.nodeRegisterCommands.join("\n");
        },
        step() {
            return this.registerMethod == "Inode_admin_only"
                ? ["0", this.$t("nodeRegisteration.step1")]
                : [this.$t("nodeRegisteration.step1"), this.$t("nodeRegisteration.step2")];
        },
        mainTitle() {
            if (this.$i18n.locale == "en-US") {
                return `Install CDN ${this.nodeType.toUpperCase()} by docker image.`;
            } else {
                return `藉由Docker映像檔來安裝CDN ${this.nodeType.toUpperCase()}`;
            }
        },
        subTitle() {
            if (this.$i18n.locale == "en-US") {
                return `This installation will setup a CDN ${this.nodeType.toUpperCase()} docker container on your host.`;
            } else {
                return `此安裝將會在您的主機上設置一個CDN ${this.nodeType.toUpperCase()} docker容器`;
            }
        },
        step1Title() {
            if (this.$i18n.locale == "en-US") {
                return `Select your CDN ${this.nodeType.toUpperCase()} registration token`;
            } else {
                return `請選擇一組${this.nodeType.toUpperCase()}註冊令牌`;
            }
        },
        step1SubTitle() {
            if (this.$i18n.locale == "en-US") {
                return `this token is the CDN ${this.nodeType.toUpperCase()} identifier`;
            } else {
                return `這個令牌是你的${this.nodeType.toUpperCase()}識別碼`;
            }
        },
        viewTokensText() {
            if (this.$i18n.locale == "en-US") {
                return `View all ${this.tokenData.length} tokens`;
            } else {
                return `查看${this.tokenData.length}筆令牌`;
            }
        },
        step2Title() {
            if (this.$i18n.locale == "en-US") {
                return `Deploy CDN ${this.nodeType.toUpperCase()} docker container`;
            } else {
                return `部署CDN ${this.nodeType.toUpperCase()} docker容器`;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/NodeRegisteration/NodeRegisterInfo.vue